export const ProvinceConstant = {
    NOT_ON_LIST: '_not_on_list_'
}